import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../../config';

const PromoCodeInput = ({ applied, onApplied, onRemoved, disabled }) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRemove = () => {
    setValue('');
    setError('');
    setOpen(false);
    onRemoved();
  };

  const apply = async () => {
    const promoCode = value.trim();
    if (!promoCode || loading || disabled) return;
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.post(
        `${API_URL}/api/subscriptions/validate-promo`,
        { promoCode },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (data?.valid) {
        onApplied({
          code: promoCode.toUpperCase(),
          trialDays: data.trialDays,
        });
        setError('');
      } else {
        setError(data?.reason || 'That code is not valid.');
      }
    } catch {
      setError("Couldn't check that code. Try again.");
    } finally {
      setLoading(false);
    }
  };

  if (applied) {
    return (
      <div className="form-group" style={{ marginBottom: 16 }}>
        <p className="helper-text" style={{ color: '#10B981', margin: '0 0 8px 0' }}>
          {applied.code} applied: {applied.trialDays} days free. Your card is saved
          today and not charged until the trial ends.
        </p>
        <button
          type="button"
          disabled={disabled}
          onClick={handleRemove}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'inherit',
            textDecoration: 'underline',
            cursor: disabled ? 'default' : 'pointer',
            fontSize: '0.85rem',
          }}
        >
          Remove
        </button>
      </div>
    );
  }

  if (!open) {
    return (
      <div className="form-group" style={{ marginBottom: 16 }}>
        <button
          type="button"
          disabled={disabled}
          onClick={() => setOpen(true)}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'inherit',
            textDecoration: 'underline',
            cursor: disabled ? 'default' : 'pointer',
            fontSize: '0.9rem',
          }}
        >
          Have a promo code?
        </button>
      </div>
    );
  }

  return (
    <div className="form-group" style={{ marginBottom: 16 }}>
      <label htmlFor="promo-code-input">Promo code</label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          id="promo-code-input"
          type="text"
          autoComplete="off"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            if (error) setError('');
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              apply();
            }
          }}
          disabled={disabled || loading}
          placeholder="Enter code"
          style={{ textTransform: 'uppercase', flex: 1, width: 'auto', minWidth: 0 }}
        />
        <button
          type="button"
          className="btn btn-secondary"
          onClick={apply}
          disabled={disabled || loading || !value.trim()}
        >
          {loading ? 'Checking...' : 'Apply'}
        </button>
      </div>
      {error ? (
        <p className="helper-text error-text" style={{ color: '#d97706', margin: '8px 0 0 0' }}>
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default PromoCodeInput;
